import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-plusOrder",
  "use": "icon-plusOrder-usage",
  "viewBox": "0 0 12 13",
  "content": "<symbol viewBox=\"0 0 12 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-plusOrder\">\n<path d=\"M11 5.875H6.625V1.5C6.625 1.15833 6.34167 0.875 6 0.875C5.65833 0.875 5.375 1.15833 5.375 1.5V5.875H1C0.658333 5.875 0.375 6.15833 0.375 6.5C0.375 6.84167 0.658333 7.125 1 7.125H5.375V11.5C5.375 11.8417 5.65833 12.125 6 12.125C6.34167 12.125 6.625 11.8417 6.625 11.5V7.125H11C11.3417 7.125 11.625 6.84167 11.625 6.5C11.625 6.15833 11.3417 5.875 11 5.875Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol